import {registerAnchor} from "@/shape/anchor";
import {registerEdge} from "@/shape/edge";
import {registerActivity} from "@/shape/activity";
import {registerHexagon} from "@/shape/hexagon";

export function registerShape(G6) {
    registerAnchor(G6)
    registerEdge(G6)
    registerActivity(G6)
    registerHexagon(G6)
}
